import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import type { DailyActivity } from "../../lib/api";

interface ActivityChartProps {
  data: DailyActivity[];
}

function formatDay(day: string): string {
  const d = new Date(day + "T00:00:00");
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

export default function ActivityChart({ data }: ActivityChartProps) {
  if (data.length === 0) {
    return (
      <div className="card p-6">
        <h2 className="section-title mb-4">Post activity</h2>
        <p className="text-sm text-faint">
          No activity yet. Generate some posts to see trends here.
        </p>
      </div>
    );
  }

  const formatted = data.map((d) => ({
    ...d,
    label: formatDay(d.day),
  }));

  return (
    <div className="card p-6">
      <h2 className="section-title mb-4">Post activity</h2>
      <ResponsiveContainer width="100%" height={280}>
        <AreaChart data={formatted}>
          <defs>
            <linearGradient id="gradGenerated" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#5457D6" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#5457D6" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gradApproved" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#10B981" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#10B981" stopOpacity={0} />
            </linearGradient>
            <linearGradient id="gradPublished" x1="0" y1="0" x2="0" y2="1">
              <stop offset="5%" stopColor="#F26B4E" stopOpacity={0.15} />
              <stop offset="95%" stopColor="#F26B4E" stopOpacity={0} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" />
          <XAxis
            dataKey="label"
            tick={{ fontSize: 11, fill: "#9CA3AF" }}
            tickLine={false}
            axisLine={{ stroke: "#E5E7EB" }}
          />
          <YAxis
            tick={{ fontSize: 11, fill: "#9CA3AF" }}
            tickLine={false}
            axisLine={false}
            allowDecimals={false}
          />
          <Tooltip
            contentStyle={{
              borderRadius: 8,
              border: "1px solid #E5E7EB",
              fontSize: 12,
            }}
          />
          <Legend
            iconType="circle"
            iconSize={8}
            wrapperStyle={{ fontSize: 12 }}
          />
          <Area
            type="monotone"
            dataKey="generated"
            name="Generated"
            stroke="#5457D6"
            fill="url(#gradGenerated)"
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="approved"
            name="Approved"
            stroke="#10B981"
            fill="url(#gradApproved)"
            strokeWidth={2}
          />
          <Area
            type="monotone"
            dataKey="published"
            name="Published"
            stroke="#F26B4E"
            fill="url(#gradPublished)"
            strokeWidth={2}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
